import { render } from "./BankDepositRecords.vue?vue&type=template&id=fe920ba6&scoped=true"
import script from "./BankDepositRecords.vue?vue&type=script&lang=js"
export * from "./BankDepositRecords.vue?vue&type=script&lang=js"

import "./BankDepositRecords.vue?vue&type=style&index=0&id=fe920ba6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe920ba6"]])

export default __exports__